const xsrfToken = document.getElementById("csrf-token")
  ? document.getElementById("csrf-token")?.getAttribute("content")
  : "90b2a60b-2d9e-4c54-9d6b-0e2de2f66e23";

// "https://isw-portal-v2.k8.isw.la/api/v1/user"
const axiosConstants = {
  USER_URL:
    process.env.NODE_ENV === "production"
      ? "/api/v1/user"
      : "http://localhost:3001/user",
  PERMISSIONS_URL:
    process.env.NODE_ENV === "production"
      ? "/api/v1/user/permissions"
      : "http://localhost:3001/permissions",
  XSRF: xsrfToken,
  SESSION: "90288e30-ab48-4a4c-b05f-200daa9b478d"
};
export default axiosConstants;
